import type { Bet, Outcome } from '../../../../../../schema/coupon/entry.js';

function toOutcome(n: number): Outcome {
  return n as Outcome;
}

function fromOutcome(outcome: Outcome): number {
  if (outcome === toOutcome(0)) {
    return 0;
  }
  if (outcome === toOutcome(1)) {
    return 1;
  }
  if (outcome === toOutcome(2)) {
    return 2;
  }

  throw new Error(`Unknown outcome: ${outcome}`);
}

/**
 * Encodes the given outcomes array into a string representation.
 *
 * @param outcomesArray The array of outcomes to encode
 * @returns The encoded string representation of the outcomes
 */
export function encodeSigns(outcomesArray: Bet): string {
  const entries: string[] = [];

  for (const [i, eventOutcomes] of outcomesArray.entries()) {
    if (eventOutcomes.length === 0 || !eventOutcomes[0] || eventOutcomes[0].length === 0) {
      continue; // skip empty entries
    }

    const [outcomes] = eventOutcomes;
    const outcomesString = outcomes.map((outcome) => {
      switch (fromOutcome(outcome)) {
        case 0:
          return '1';
        case 1:
          return 'X';
        case 2:
          return '2';
        default:
          throw new Error(`Invalid outcome: ${outcome}`);
      }
    });

    const entry = `${i + 1}:${outcomesString.join(';')}`;
    entries.push(entry);
  }

  return entries.join(',');
}
